import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check localStorage first, then system preference
    const saved = localStorage.getItem('tinbox-theme');
    if (saved) return saved;

    // Check system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  });

  const [colorScheme, setColorScheme] = useState(() => {
    const saved = localStorage.getItem('tinbox-color-scheme');
    return saved || 'purple'; // Default to purple (tinbox.app style)
  });

  useEffect(() => {
    // Apply theme to document
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('tinbox-theme', theme);
  }, [theme]);

  useEffect(() => {
    // Apply color scheme to document
    document.documentElement.setAttribute('data-color-scheme', colorScheme);
    localStorage.setItem('tinbox-color-scheme', colorScheme);
  }, [colorScheme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const toggleColorScheme = () => {
    setColorScheme(prev => prev === 'blue' ? 'purple' : 'blue');
  };

  const setLightTheme = () => setTheme('light');
  const setDarkTheme = () => setTheme('dark');

  return (
    <ThemeContext.Provider value={{
      theme, toggleTheme, setLightTheme, setDarkTheme,
      colorScheme, setColorScheme, toggleColorScheme
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export default ThemeContext;
